<div class="cell-content" [style.background-color]="cellBackgroundColor">
    <ng-container *ngIf="sentimentEmojiIcon; else showValue">
        <div class="emoji-container">
            <svg class="emoji-icon" [ngStyle]="getSentimentIconStyle(currentSentimentLabel)">
                <use [attr.href]="sentimentEmojiIcon"></use>
            </svg>
        </div>
    </ng-container>
    <ng-template #showValue>
        {{ params?.value }}
    </ng-template>
</div>